export default function UsersService($http, appSettings, $q, gettextCatalog) {
  'ngInject';
  var _currentUser = null;

  this.currentUser = function () {
    return _currentUser;
  };

  this.getCurrentUser = function () {
    var endpoint = appSettings.InReachApiEndpoint + '/users/me';
    var def = $q.defer();

    $http.get(endpoint).then(
      response => {
        _currentUser = response.data;
        return def.resolve(response);
      },
      () => def.reject(gettextCatalog.getString('failed to get current user'))
    );
    return def.promise;
  };

  this.getUsers = function () {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users';

    return $http.get(endpoint);
  };
  this.getUserClaims = function () {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users/me/claims';

    return $http.get(endpoint);
  };
  this.updateUserClaims = function (claims) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users/me/claims';

    return $http.put(endpoint, claims);
  };
  this.changeEmail = function (newemail) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users/me/email';

    return $http.post(endpoint, newemail);
  };

  this.getUser = function (id) {
    if (!id) {
      return id;
    }

    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users/' + id;

    return $http.get(endpoint);
  };

  this.updateUserInfo = function (id, firstName, lastName) {
    if (!id) {
      return id;
    }
    var userId = id;
    var userInfo = [{
      op: 'update',
      claims: {
        firstName: firstName || '',
        lastName: lastName || ''
      }
    }];
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users';

    return $http.patch(endpoint + '/' + userId + '/claims', userInfo);
  };

  this.postUserInfo = function (id, firstName, lastName) {
    if (!id) {
      return id;
    }
    var userId = id;
    var userInfo = [{
      op: 'add',
      claims: {
        firstName: firstName || '',
        lastName: lastName || ''
      }
    }];
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users';

    return $http.patch(endpoint + '/' + userId + '/claims', userInfo);
  };

  this.postUserRole = function (userRole) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/roles';
    return $http.post(endpoint, userRole);
  };

  this.changePassword = function (model) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users/me/password';
    return $http.post(endpoint, model);
  };

  this.getRoles = function () {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/roles';

    return $http.get(endpoint);
  };

  this.getRoleDetails = function (id) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/roles/' + id;

    return $http.get(endpoint);
  };
  this.deleteRoleDetails = function (id) {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/roles/' + id;

    return $http.delete(endpoint);
  };

  this.putRoleDetails = function (data) {
    if (!data || !data.id) return; //Invalid role details

    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/roles/' + data.id;

    return $http.put(endpoint, data);
  };

  this.getRolePolicies = function () {
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/policies';
    return $http.get(endpoint);
  };

  this.getDatapoints = function () {
    var endpoint = appSettings.IcebergApiDatapointsEndpoint;
    return $http.get(endpoint + '/datapoints');
  };

  this.getDataPointsByRoleIds = function (ids) {
    var endpoint = appSettings.IcebergApiDatapointsEndpoint;
    return $http.get(endpoint + '/datapoints', {
      params: {
        role: JSON.stringify(ids)
      }
    });
  };

  this.patchUserRoles = function (id, changes) {
    if (!id) {
      return id;
    }
    var userId = id;
    var endpoint = appSettings.IcebergApiUserInfoEndpoint + '/users';

    return $http.patch(endpoint + '/' + userId + '/roles', changes);
  };
}